<template>

    <header class="fuid-header">

        <b-container class="container-redo">

            <b-row class="fuid-langsitcher_container">

                <b-col class="d-flex justify-content-center fuid-header__logo">

                    <router-link :to="`/${locale}`">
                        
                        <FundacionLogo class="fuid-logo__svg" />
                        
                    </router-link>
                    
                </b-col>

                <b-col class="fuid-langsitcher">

                    <langSwitcher />

                </b-col>
            
            </b-row>

            <b-row>

                <b-col cols="12">

                    <h1 class="fuid-hedader__tit">{{ $t('header.h1') }}</h1>
                    <p class="fuid-header__text">{{ $t('header.txt') }}</p>

                </b-col>
            
            </b-row>

        </b-container>

    </header>

</template>

<script>

    import FundacionLogo from '@/assets/svg/fundacion-idiomas-fundazioa.svg'
    import langSwitcher from '@/components/langSwitcher.vue'

    export default {
        
        components: {

            FundacionLogo,
            langSwitcher

        },

        computed: {

            locale: function () {

                return this.$i18n.locale

            }

        }

    }
    
</script>

<style lang="scss">
    @import '@/assets/scss/_layout';
</style>